// middleware/auth.global.ts
import {
  defineNuxtRouteMiddleware,
  useSupabaseUser,
  navigateTo,
} from "#imports";

export default defineNuxtRouteMiddleware((to) => {
  const user = useSupabaseUser();

  const protectedPrefixes = ["/dashboard", "/payment", "/admin"];

  const isProtectedRoute = protectedPrefixes.some((prefix) =>
    to.path.startsWith(prefix)
  );

  // SSR'da `user.value` null olabilir, client side kontrol önemli
  if (import.meta.client && isProtectedRoute && !user.value) {
    return navigateTo("/?auth_required=true");
  }
});
